
import { Component, Prop, Vue } from 'vue-property-decorator';
import SignGesture from '@/repositories/data/SignGesture';
import { mediaEndpoint } from '@/container';

@Component
export default class SignGestureImage extends Vue {
    @Prop({ type: Object, required: true }) public readonly signGesture!: SignGesture;

    public get src(): string {
        return mediaEndpoint + '/sign/gesture/' + this.signGesture.id;
    }

    public get alt(): string | null {
        return this.signGesture.labelNl || null;
    }
}
